/* Conversione delle date che arrivano dal backend.
 *
 * Spring serializza LocalDateTime come ARRAY di numeri
 * [anno, mese, giorno, ora, minuto, secondo, nano], non come stringa ISO,
 * perche' WRITE_DATES_AS_TIMESTAMPS e' attivo. Passandolo a new Date() si
 * ottiene "Invalid Date".
 *
 * Qui si accettano entrambe le forme: l'array del backend e la stringa, cosi'
 * se un domani la configurazione Jackson venisse cambiata il frontend
 * continuerebbe a funzionare senza modifiche.
 */

export const aData = (valore) => {
  if (!valore) return null;

  if (Array.isArray(valore)) {
    // Il mese in JavaScript parte da 0, nell'array del backend da 1.
    const [anno, mese, giorno, ora = 0, minuto = 0, secondo = 0] = valore;
    if (!anno || !mese || !giorno) return null;
    return new Date(anno, mese - 1, giorno, ora, minuto, secondo);
  }

  const d = new Date(valore);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** Solo la data, es. 24/10/2026. */
export const formattaData = (valore, ripiego = '—') => {
  const d = aData(valore);
  return d ? d.toLocaleDateString('it-IT') : ripiego;
};

/** Data e ora, es. 24/10/2026, 12:08. */
export const formattaDataOra = (valore, ripiego = '—') => {
  const d = aData(valore);
  return d
    ? d.toLocaleString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : ripiego;
};

/** Ora in formato breve da "20:00:00" o da un array. */
export const formattaOra = (valore) => {
  if (!valore) return '';
  if (Array.isArray(valore)) {
    const [ora = 0, minuto = 0] = valore;
    return `${String(ora).padStart(2, '0')}:${String(minuto).padStart(2, '0')}`;
  }
  return String(valore).substring(0, 5);
};
